import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/apiConfig";
import VCardPublicCard from "@/components/VCardPublicCard";

export default function VCardPage() {
  const { slug } = useParams();
  const [card,setCard] = useState(null);
  const [missing,setMissing] = useState(false);
  useEffect(()=>{axios.get(`${API}/public/vcards/${encodeURIComponent(slug)}`).then(response=>setCard(response.data)).catch(()=>setMissing(true));},[slug]);
  useEffect(()=>{
    if(!card)return;
    document.title=card.seo_title||`${card.first_name||"Contact"} · ${card.company||"Eudemonie"}`;
    let meta=document.querySelector('meta[name="description"]');
    if(!meta){meta=document.createElement("meta");meta.name="description";document.head.appendChild(meta);}
    meta.content=card.seo_description||card.presentation||"Carte de visite numérique";
    let canonical=document.querySelector('link[rel="canonical"]');
    if(!canonical){canonical=document.createElement("link");canonical.rel="canonical";document.head.appendChild(canonical);}
    canonical.href=`${window.location.origin}/vCard/${card.slug}`;
  },[card]);
  if(missing)return <div className="flex min-h-screen items-center justify-center bg-bone-light p-6 text-center"><div><h1 className="font-playfair text-3xl text-charcoal">Carte indisponible</h1><p className="mt-2 text-sm text-charcoal-muted">Cette carte de visite n’est pas publiée ou n’existe pas.</p></div></div>;
  if(!card)return <div className="flex min-h-screen items-center justify-center bg-bone-light"><div className="h-8 w-8 animate-spin rounded-full border-2 border-sage border-t-transparent"/></div>;
  return <div className="min-h-screen bg-bone-light py-3 sm:py-8"><VCardPublicCard card={card} vcfUrl={`${API}/vCard/${encodeURIComponent(card.slug)}.vcf`}/></div>;
}
